// Root DOM handles and the small primitives every view relies on.
import { t } from "../i18n.js";
import { state } from "../state.js";

export const app = document.querySelector("#app");

const toast = document.querySelector("#toast");

export function escapeHTML(value = "") {
  return String(value).replace(/[&<>"']/g, character => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;"
  })[character]);
}

export function showToast(message) {
  toast.textContent = message;
  toast.hidden = false;
  clearTimeout(showToast.timer);
  showToast.timer = setTimeout(() => { toast.hidden = true; }, 4500);
}

export function setBusy(button, busy = true) {
  state.busy = busy;
  if (!button) return;
  button.disabled = busy;
  button.dataset.originalText ||= button.textContent;
  button.textContent = busy ? t("loading") : button.dataset.originalText;
}

export function showModal(content) {
  const backdrop = document.createElement("div");
  backdrop.className = "modal-backdrop";
  backdrop.id = "modal-backdrop";
  backdrop.innerHTML = `<div class="modal">${content}</div>`;
  document.body.append(backdrop);
  backdrop.addEventListener("click", event => {
    if (event.target === backdrop || event.target.closest("[data-close-modal]")) closeModal();
  });
}

export function closeModal() {
  document.querySelector("#modal-backdrop")?.remove();
}
